import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const SalaryManagerDetail = React.lazy(() => import('../components/SalaryManagerDetail'));
function SalaryManagerDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <SalaryManagerDetail {...props} />
    </Suspense>
  );
}

export default SalaryManagerDetailView;
